import React from 'react';
import ReactPaginate from 'react-paginate';
import PropsTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { LIMIT_GET_LIST } from '../../constants/constants';
import styled from '@emotion/styled';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
const Pagination = (props) => {
  const {
    pageCount,
    onChangePage,
    currentPage,
    limit,
    currentItem,
    totalItems,
    learnerPage,
  } = props;
  function handleChangePage({ selected }) {
    if (selected + 1 !== currentPage) {
      onChangePage(selected + 1);
    }
  }
  const themeStatus = useSelector(getThemeColor);
  const colorTextStatus = useSelector(getColor);
  const colorStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .custom__pagination {
      &__item {
        border: 1px solid;
        margin-left: 0.1rem;
        margin-right: 0.1rem;
        width: 3rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.4rem;
        a {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &--active {
          border-color: ${colorTextStatus};
          background-color: ${colorTextStatus};
          color: white;
          font-weight: bold;
        }
      }
    }
  `;
  return (
    <div className="display-inline-flex flexRow justify-content-center align-items-center">
      <Stylescal className={learnerPage ? 'd-flex' : null}>
        <ReactPaginate
          previousLabel={<ChevronLeft size={16} />}
          nextLabel={<ChevronRight size={16} />}
          breakLabel="..."
          breakClassName="break-me"
          pageCount={pageCount}
          initialPage={currentPage - 1}
          forcePage={currentPage - 1}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={handleChangePage}
          containerClassName="pagination"
          pageClassName="custom__pagination__item"
          previousClassName="custom__pagination__item"
          nextClassName="custom__pagination__item"
          subContainerClassName="pages pagination"
          activeClassName="custom__pagination__item custom__pagination__item--active"
        />
        {typeof currentItem === 'number' ? (
          <span className="px-04 mb-1">
            {`${
              currentPage === 1 && currentItem === 0
                ? 0
                : (learnerPage ? 2 : limit) * (currentPage - 1) + 1
            } - ${
              (learnerPage ? 2 : limit) * (currentPage - 1) + currentItem
            } of ${totalItems}`}
          </span>
        ) : null}
      </Stylescal>
    </div>
  );
};

Pagination.defaultProps = {
  limit: LIMIT_GET_LIST,
};

Pagination.prototype = {
  limit: PropsTypes.number,
  pageCount: PropsTypes.number.isRequired,
  onChangePage: PropsTypes.func.isRequired,
  currentPage: PropsTypes.number.isRequired,
  currentItem: PropsTypes.number,
  totalItems: PropsTypes.number,
};

export default Pagination;
